import { makeStyles, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles({
  tooltip: {
    width: 388,
    maxWidth: 388,
    minWidth: 388,
  },
  text: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
})

const SocialMediaChartHelpIcon: FC = () => {
  const classes = useStyles()
  return (
    <Tooltip
      title={
        <Typography variant="body1" className={classes.text}>
          The number of words entered into the Ksana Keyboard each day. If the
          value exceeds the chart's display range, the exact value can be viewed
          on mouseover.
        </Typography>
      }
      className={classes.tooltip}
    >
      <HelpIcon />
    </Tooltip>
  )
}

export default SocialMediaChartHelpIcon
